// import './escaper';
import $ from 'jquery';
$(document).ready(function () {
    $('.slick-slide .wp-block-cg-blocks-career-invent-sogeti a.sogeti-button').attr('tabindex', '0');
    const updateSingleSlideState = function ($slider) {
        const $section = $slider.closest('.section--event-slider-careerInvent');
        let slideCount = $slider.find('.slide').not('.slick-cloned').length;
        if ($slider.hasClass('slick-initialized') && $slider[0] && $slider[0].slick) {
            slideCount = $slider[0].slick.slideCount;
        }
        const isSingleSlide = slideCount <= 1;
        $section.find('.slide.slick-slide').attr('tabindex', isSingleSlide ? '-1' : '0');
        $section.find('.slick-dots').toggle(!isSingleSlide);
    };
    const sliderSelector = '.section--event-slider-careerInvent .slider';
    $(sliderSelector).each(function () {
        updateSingleSlideState($(this));
    });
    $(document).on('init reInit breakpoint setPosition', sliderSelector, function () {
        updateSingleSlideState($(this));
    });
});
